import { FC } from "react";
import useUserData from "repository/useUser";
import useBID from "utils/useBid";
import LoadingForm from "./LoadingForm";
import SettingForm from "./SettingForm";
import useSettingPage from "./useSettingPage";

const SettingPage: FC = () => {
  const { branch, isLoading, isError } = useSettingPage();
  const bId = useBID();
  const { data: user, isLoading: isUserLoading } = useUserData();

  if (isLoading || isUserLoading) return <LoadingForm />;
  if (isError || !user) return <p>データの取得でエラーが発生しました。</p>;
  if (!user.editableBranches.map((branch) => branch.bId).includes(bId)) {
    return (
      <p>
        この店舗を設定する権限がありません。お手数ですがログインしているアカウントをお確かめください。
      </p>
    );
  }
  return (
    <>
      {branch?.isUseLotteryAndCoupon ? (
        <SettingForm branch={branch} />
      ) : (
        <span>
          抽選・クーポン設定を行うにはReCoPoチームへお問い合わせください。
        </span>
      )}
    </>
  );
};

export default SettingPage;
